import { ReactNode, memo } from "react";
import { Container } from "react-bootstrap";
import { styled } from "styled-components";

const StyledConainer = styled(Container)`
  max-width: 992px;
  padding: 0;
`;

interface PageProps {
  children: ReactNode;
}

const Page = (props: PageProps) => {
  const { children } = props;

  return <StyledConainer>{children}</StyledConainer>;
};

export default memo(Page);
